import { render, staticRenderFns } from "./IncomeStep.vue?vue&type=template&id=2c412aa2&lang=pug"
import script from "./IncomeStep.vue?vue&type=script&lang=js"
export * from "./IncomeStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports